import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { displayMessages, destroyMessages } from 'stdjs/validation';
import 'bootstrap';

export function confirmModel(url, data, successCallback, domPrefix, modalTitle, modalMessage, confirmButtonText, cancelButtonText){

    destroyMessages();

    if (typeof domPrefix === "undefined"){
        domPrefix = "";
    }
    
    var dialogId = "CONFIRMMODAL";
    var submitButtonId = "confirmModelConfirm";
    var cancelButtonId = "confirmModelCancel";

    var oDiv = document.createElement("div");
    oDiv.setAttribute("id", dialogId);
    oDiv.setAttribute("tab-index", -1);
    oDiv.setAttribute("role", "dialog");
    $(oDiv).addClass("modal");
    $(oDiv).addClass("fade");
    oDiv = $(oDiv);
    
    $("body").append(oDiv);
    
    oDiv.html("\
        <div class=\"card modal-dialog\" role=\"document\">\
            <div class=\"modal-content\">\
                <div class=\"modal-header  card-header\">\
                    <div class=\"row no-gutters w-100\">\
                        <div class=\"col-12 text-sm-center text-lg-left\">\
                            <div class=\"d-flex\">\
                                <span class=\"card-header-title flex-grow-1\">" + modalTitle + "</span>\
                                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\
                                    <span aria-hidden=\"true\">&times;</span>\
                                </button>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                <div class=\"modal-body card-body\">\
                    <div class=\"row\">\
                        <div class=\"col\">\
                            <div class=\"\">\
                                " + modalMessage + "\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                <div class=\"modal-footer justify-content-around\">\
                    <button id=\"" + cancelButtonId + "\" class=\"btn stdButton\">" + cancelButtonText + "</button>\
                    <button id=\"" + submitButtonId + "\" class=\"btn stdButton\">" + confirmButtonText + "</button>\
                </div>\
            </div>\
        </div>\
    ");

    oDiv.modal();
    oDiv.on("hidden.bs.modal", function(e){
        oDiv.remove();
    });
    
    var $submitButton = $(domPrefix + "#" + submitButtonId);
    var $cancelButton = $(domPrefix + "#" + cancelButtonId);

    $cancelButton.click(function(event) {
        oDiv.modal("hide");
    });

    $submitButton.click(function(event) {

        var modifiedSuccessCallback = function(data){
            oDiv.on("hidden.bs.modal", function(e){
                successCallback(data);
            });
            oDiv.modal("hide");
        }

        var errorCallback = function(data){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
            oDiv.modal("hide");
        }
        if (url === null){
            modifiedSuccessCallback({});
        } else {
            standardAjaxPost(url, data, modifiedSuccessCallback, errorCallback);
        }

    });

}